<template>
     <div class="modal" id="auth-modal">
        <div class="modal-background" @click="canDismiss ? toggleModal() : null"></div>
        <div class="modal-card">
            <div class="modal-card-body">
                <div class="title has-text-centered" v-if="modal === 'sign-in'">Vous n'êtes pas connecté</div>
                <div class="columns">
                    <div class="column" v-if="modal === 'sign-in'">
                        <sign-in
                            v-on:showSignUp="modal = 'sign-up'"
                            v-on:userLogin="$emit('userLogin', $e)"
                            v-on:forgottenPassword="modal = 'forgotten-password'"
                        ></sign-in>
                    </div>
                    <div class="column" v-if="modal === 'sign-up'">
                        <sign-up
                            v-on:showSignIn="modal = 'sign-in'"
                            v-on:userLogin="$emit('userLogin', $e)"
                            v-bind:withAuth="withAuth"
                            v-on:submitWithoutAuth="(client) => $emit('submitWithoutAuth', client)"
                        ></sign-up>
                    </div>
                    <div class="column" v-if="modal === 'forgotten-password'">
                        <forgotten-password
                            v-on:showSignIn="modal = 'sign-in'"
                        ></forgotten-password>
                    </div>
                </div>
            </div>

        </div>
        <button v-if="canDismiss" class="modal-close is-large" aria-label="close" @click="toggleModal()"></button>
    </div>
</template>

<script>
import ForgottenPassword from '../Profile/ForgottenPassword.vue'
import SignIn from '../Profile/SignIn.vue'
import SignUp from '../Profile/SignUp.vue'
export default {
    name: 'AuthModal',
    props: ["withAuth","autoBooking"],
    emits: ['submitWithoutAuth'],
    components: {ForgottenPassword, SignIn, SignUp},
    data () {
        return {
            modal: "sign-in",
            canDismiss: true,
        }
    },
    methods: {
        toggleModal () {
            let modal = document.querySelector('#auth-modal')
            modal.classList.toggle('is-active')
        }
    },
    mounted(){
        this.modal = this.withAuth ? "sign-in" : "sign-up";
        this.canDismiss = !this.autoBooking;
    }
}
</script>
<style scoped>
#auth-modal {
    z-index: 9999;
}
#auth-modal > .modal-card {
    border-radius: 15px;
    max-height: 88%;
}
.modal-card > .modal-card-body > .columns {
    height: 100%;
}
.modal-card > .modal-card-body > .columns > .column {
    height: 100%;
    overflow-y: auto;
}
</style>
